import React from 'react';
import { motion, HTMLMotionProps } from 'framer-motion';
import { clsx } from 'clsx';
interface ButtonProps extends HTMLMotionProps<'button'> {
  variant?: 'primary' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  children: React.ReactNode;
}
export function Button({
  variant = 'primary',
  size = 'md',
  className,
  children,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-[#C9A962] focus:ring-offset-2 focus:ring-offset-[#0A0A0A] disabled:opacity-50 disabled:pointer-events-none';
  const variants = {
    primary: 'bg-[#C9A962] text-[#0A0A0A] hover:bg-[#B08D45]',
    outline: 'border border-[#C9A962] text-[#C9A962] hover:bg-[#C9A962]/10',
    ghost: 'text-[#F5F5F0] hover:text-[#C9A962] hover:bg-[#C9A962]/5'
  };
  const sizes = {
    sm: 'h-9 px-4 text-sm',
    md: 'h-11 px-6 text-base',
    lg: 'h-14 px-8 text-lg'
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={clsx(baseStyles, variants[variant], sizes[size], className)} {...props} data-id="element-208">
      {children}
    </motion.button>;
}